var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap" },
              attrs: { gutter: 24, type: "flex", justify: "left" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "div",
                          { staticClass: "searchNumberType" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { size: "small" },
                                on: { change: _vm.numTypeChange },
                                model: {
                                  value: _vm.numberType,
                                  callback: function ($$v) {
                                    _vm.numberType = $$v
                                  },
                                  expression: "numberType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("placeOrder.scanOrderNumber"),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "orderCenterCont.anjunWaybillNumber"
                                    ),
                                    value: 2,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.numberType === 1
                        ? _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.max200Line"
                              ),
                              rows: 1,
                              type: "textarea",
                              clearable: "",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.BlockNewline("scanOrderNumber")
                              },
                            },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.BlockNewline("scanOrderNumber")
                              },
                            },
                            model: {
                              value: _vm.queryForm.params.scanOrderNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "scanOrderNumber",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.scanOrderNumber",
                            },
                          })
                        : _vm._e(),
                      _vm.numberType === 2
                        ? _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.max200Line"
                              ),
                              rows: 1,
                              type: "textarea",
                              clearable: "",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.BlockNewline("waybillNumber")
                              },
                            },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.BlockNewline("waybillNumber")
                              },
                            },
                            model: {
                              value: _vm.queryForm.params.waybillNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "waybillNumber",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.waybillNumber",
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("collectionCenter.CustomerName") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "customerId", $$v)
                            },
                            expression: "queryForm.params.customerId",
                          },
                        },
                        _vm._l(_vm.customerIdList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.username, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.OperationSite"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "GlobalSetObj.Only10AreDisplayed"
                            ),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            size: "small",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.remoteGetSiteList,
                          },
                          on: { clear: _vm.remoteGetSiteList },
                          model: {
                            value: _vm.queryForm.params.operateSiteId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "operateSiteId",
                                $$v
                              )
                            },
                            expression: "queryForm.params.operateSiteId",
                          },
                        },
                        _vm._l(_vm.siteList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.operationTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: false,
                          "default-time": ["00:00:00", "23:59:59"],
                          placeholder: _vm.$t("newOrder.SelectDatetime"),
                          "range-separator": "~",
                          size: "small",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: { change: _vm.timeChange },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 5 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "4px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.search },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      { attrs: { size: "mini" }, on: { click: _vm.reset } },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-divider", { staticClass: "divider_class" }),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "success" },
          on: { click: _vm.chooseExport },
        },
        [_vm._v(_vm._s(_vm.$t("collectionCenter.export1")) + " ")]
      ),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "success" },
          on: { click: _vm.toExport },
        },
        [_vm._v(_vm._s(_vm.$t("collectionCenter.allExport")) + " ")]
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            "max-height": "600",
            border: "",
            "header-cell-style": { background: "#ebebeb", color: "#606266" },
            data: _vm.tableData,
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", type: "selection", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              width: "60",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "scanOrderNumber",
              align: "center",
              label: _vm.$t("collectionCenter.ScanNumber"),
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "waybillNumber",
              align: "center",
              label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "customerName",
              align: "center",
              label: _vm.$t("collectionCenter.CustomerName"),
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplementCollectTime",
              align: "center",
              label: _vm.$t("collectionCenter.supplementCollectionTime"),
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operateTime",
              align: "center",
              label: _vm.$t("basicData.OperationTime"),
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operateSiteName",
              align: "center",
              label: _vm.$t("collectionCenter.OperationSite"),
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operateUserName",
              align: "center",
              label: _vm.$t("collectionCenter.controlsEmployee"),
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operateNode",
              align: "center",
              label: _vm.$t("Resource.OperationNode"),
              "min-width": "130",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryForm.pageNumber,
              "page-sizes": [10, 20, 50, 100, 500, 1000],
              "page-size": _vm.queryForm.pageSize,
              total: _vm.total,
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.currentPage,
              "size-change": _vm.sizePage,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }